// extracted by mini-css-extract-plugin
export default {"container":"kvkuTLkO24YQnwbF9CfL"};